import React, { useState, forwardRef, useEffect } from "react";

import { InputText } from "primereact/inputtext";
import MeaCreateModal from "../../../../components/MeaCreateModal";
import { InputTextarea } from "primereact/inputtextarea";
import levelsAPI from "../../../../services/levels";
import { Dropdown } from "primereact/dropdown";
import classesAPI from "../../../../services/classes";
import { InputNumber } from "primereact/inputnumber";
import teachersAPI from "../../../../services/teachers";

const CreateClasseModal = forwardRef((props, ref) => {
  //
  const [name, setName] = useState("");
  const [presentation, setPresentation] = useState("");
  const [levelId, setLevelId] = useState(props.levelId || "");
  const [maxCapacity, setMaxCapacity] = useState(20);
  const [referentId, setReferentId] = useState("");
  //
  const levelsList = levelsAPI.useGetList(
    props.schoolId,
    props.trainingId,
    props.accessToken,
    1,
    100000
  );
  const uniqueLevels = levelsList.data?.data || [];
  uniqueLevels.sort((a, b) => a.show_order - b.show_order);
  const listLevels = uniqueLevels.map((level, index) => ({
    label: level.name,
    value: level.id,
  }));

  const teachersList = teachersAPI.useGetList(
    props.schoolId,
    props.trainingId,
    props.accessToken,
    1,
    100000
  );
  const uniqueTeachers = teachersList.data?.data || [];
  uniqueTeachers.sort((a, b) => {
    const nameA = a.member?.lastname || a.member?.name || "";
    const nameB = b.member?.lastname || b.member?.name || "";
    return nameA.localeCompare(nameB);
  });
  const listTeachers = uniqueTeachers.map((teacher) => ({
    label: teacher.member?.name
      ? teacher.member.name
      : (teacher.member?.lastname?.toUpperCase() || "") + " " + (teacher.member?.firstname || ""),
    value: teacher.member?.id,
  }));
  listTeachers.unshift({
    label: "-",
    value: "",
  });

  useEffect(() => {
    if (levelId === "" && listLevels.length > 0) {
      setLevelId(listLevels[0].value);
    }
  }, [listLevels, levelId]);

  return (
    <>
      <MeaCreateModal
        ref={ref}
        title="Créer une classe"
        serviceAPI={classesAPI}
        schoolId={props.schoolId}
        trainingId={props.trainingId}
        accessToken={props.accessToken}
        data={{
          name: name,
          presentation: presentation,
          level_id: levelId,
          max_capacity: maxCapacity,
          referent_id: referentId || null,
          show_order: 0,
        }}
        onSubmitted={() => {
          setName("");
          setPresentation("");
          setMaxCapacity(20);
          setReferentId("");
        }}
      >
        <label htmlFor="name" className="block text-900 font-medium mb-2">
          Nom de la classe
        </label>
        <InputText
          id="name"
          type="text"
          value={name}
          onChange={(e) => setName(e.target.value)}
          className="w-full mb-3"
          autoFocus
        />
        <label
          htmlFor="presentation"
          className="block text-900 font-medium mb-2"
        >
          Présentation
        </label>
        <InputTextarea
          id="presentation"
          type="text"
          value={presentation}
          onChange={(e) => setPresentation(e.target.value)}
          rows={3}
          className="w-full mb-3"
        />
        <label htmlFor="name" className="block text-900 font-medium mb-2">
          Niveau de la classe
        </label>
        <Dropdown
          value={levelId}
          disabled={props.levelId !== undefined}
          onChange={(e) => setLevelId(e.value)}
          options={listLevels}
          optionLabel="label"
          optionValue="value"
          className="w-full mb-3"
        />
        <label htmlFor="referent" className="block text-900 font-medium mb-2">
          Référent(e)
        </label>
        <Dropdown
          id="referent"
          value={referentId}
          onChange={(e) => setReferentId(e.value)}
          options={listTeachers}
          optionLabel="label"
          optionValue="value"
          className="w-full mb-3"
        />
        <label htmlFor="number-maxCapacity">Capacité maximale</label>
        <InputNumber
          id="maxCapacity"
          value={maxCapacity}
          onValueChange={(e) => setMaxCapacity(e.value)}
        />
      </MeaCreateModal >
    </>
  );
});

export default CreateClasseModal;
